// Flags comments where the customer wants something done to their order —
// cancelling a line, swapping a colour/size, "namiesto ciernej modru". We
// deliberately don't distinguish which: the operator reads the comment and
// opens the order if needed, so one "needs a reply" signal is enough.
//
// Stems are matched after diacritics are stripped, so `zrus` covers `zrušte`,
// `zrušiť`, `zrusit`. SK + CZ. Extend as real traffic shows new phrasings.
//
// `misto` is the Czech "místo" (instead of); Slovak "miesto" (a place) keeps
// its `ie` after stripping, so "mam miesto" doesn't trip the match.
const intentStems = [
  'zrus\\w*',
  'storn\\w*',
  'rusim',
  'rusime',
  'rusit',
  'nechc\\w*',
  'netreb\\w*',
  'nepotrebuj\\w*',
  'odhlas\\w*',
  'vymaz\\w*',
  'zmaz\\w*',
  'smaz\\w*',
  'cancel\\w*',
  'vymen\\w*',
  'zamen\\w*',
  'prehod\\w*',
  'zmen\\w*',
  'namiesto',
  'namisto',
  'misto',
  'da[jt]\\w*\\s+prec',
  'de[jt]\\w*\\s+pryc',
];

const intentRegex = new RegExp(`\\b(?:${intentStems.join('|')})\\b`);

const stripDiacritics = (value: string) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

export const hasActionIntent = (body: string) =>
  intentRegex.test(stripDiacritics(body).toLowerCase());
